import { render, staticRenderFns } from "./LProjectConfigurationImage.vue?vue&type=template&id=164d35e4&scoped=true&"
import script from "./LProjectConfigurationImage.vue?vue&type=script&lang=js&"
export * from "./LProjectConfigurationImage.vue?vue&type=script&lang=js&"
import style0 from "./LProjectConfigurationImage.vue?vue&type=style&index=0&id=164d35e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d35e4",
  null
  
)

export default component.exports